// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tableSection__8nKW\\+ {
  position: relative;
  overflow-x: auto;
  background-color: #ffffff;
}

.styles_tableOverlay__QoUDl {
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.styles_table__qwf2F {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  /* Colunas fixas somam ~55rem; a Razão Social ocupa o resto (mín. 14rem). */
  min-width: 70rem;
}

.styles_table__qwf2F thead {
  background-color: #fafafa;
}

.styles_table__qwf2F th {
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
  color: #424242;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 10px 16px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.styles_table__qwf2F td {
  border-bottom: 1px solid #f0f0f0;
  box-sizing: border-box;
  color: #424242;
  font-size: 0.875rem;
  height: 56px;
  overflow: hidden;
  padding: 8px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_table__qwf2F tbody tr:hover {
  background-color: #fafafa;
}

.styles_colRazao__lRBiD {
  min-width: 14rem;
}

.styles_colId__FrPqv {
  width: 8rem;
}

.styles_colCnpj__44j2k {
  width: 11rem;
}

.styles_colTipo__sxXc2 {
  width: 8rem;
}

.styles_colData__zbNmU {
  width: 8rem;
}

.styles_colValor__wP1uu {
  width: 9rem;
  text-align: right !important;
}

.styles_colStatus__pDSVl {
  width: 8rem;
}

.styles_colAcoes__gDo4Q {
  width: 8rem;
}

.styles_table__qwf2F td.styles_colStatus__pDSVl {
  overflow: visible;
  text-overflow: clip;
}

.styles_acoesCell__m-eqL {
  align-items: center;
  display: flex;
  gap: 4px;
}

.styles_emptyRow__7uG9E td {
  color: #18316e;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  padding: 2.5rem 1rem;
  text-align: center;
  white-space: normal;
}

.styles_loadingWrap__xLo3e {
  min-height: 280px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProjetosApuracao/Lista/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,2EAA2E;EAC3E,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".tableSection {\n  position: relative;\n  overflow-x: auto;\n  background-color: #ffffff;\n}\n\n.tableOverlay {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n}\n\n.table {\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  /* Colunas fixas somam ~55rem; a Razão Social ocupa o resto (mín. 14rem). */\n  min-width: 70rem;\n}\n\n.table thead {\n  background-color: #fafafa;\n}\n\n.table th {\n  border-bottom: 1px solid #e0e0e0;\n  box-sizing: border-box;\n  color: #424242;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  padding: 10px 16px;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.table td {\n  border-bottom: 1px solid #f0f0f0;\n  box-sizing: border-box;\n  color: #424242;\n  font-size: 0.875rem;\n  height: 56px;\n  overflow: hidden;\n  padding: 8px 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.colRazao {\n  min-width: 14rem;\n}\n\n.colId {\n  width: 8rem;\n}\n\n.colCnpj {\n  width: 11rem;\n}\n\n.colTipo {\n  width: 8rem;\n}\n\n.colData {\n  width: 8rem;\n}\n\n.colValor {\n  width: 9rem;\n  text-align: right !important;\n}\n\n.colStatus {\n  width: 8rem;\n}\n\n.colAcoes {\n  width: 8rem;\n}\n\n.table td.colStatus {\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.acoesCell {\n  align-items: center;\n  display: flex;\n  gap: 4px;\n}\n\n.emptyRow td {\n  color: #18316e;\n  font-size: 1rem;\n  font-weight: 500;\n  height: auto;\n  padding: 2.5rem 1rem;\n  text-align: center;\n  white-space: normal;\n}\n\n.loadingWrap {\n  min-height: 280px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableSection": `styles_tableSection__8nKW+`,
	"tableOverlay": `styles_tableOverlay__QoUDl`,
	"table": `styles_table__qwf2F`,
	"colRazao": `styles_colRazao__lRBiD`,
	"colId": `styles_colId__FrPqv`,
	"colCnpj": `styles_colCnpj__44j2k`,
	"colTipo": `styles_colTipo__sxXc2`,
	"colData": `styles_colData__zbNmU`,
	"colValor": `styles_colValor__wP1uu`,
	"colStatus": `styles_colStatus__pDSVl`,
	"colAcoes": `styles_colAcoes__gDo4Q`,
	"acoesCell": `styles_acoesCell__m-eqL`,
	"emptyRow": `styles_emptyRow__7uG9E`,
	"loadingWrap": `styles_loadingWrap__xLo3e`
};
export default ___CSS_LOADER_EXPORT___;
